import { ContainerOutlined } from '@ant-design/icons'
import { useBoolean } from 'ahooks'
import { Button, Modal, Tooltip } from 'antd'
import { useTheme } from 'antd-style'

import { FreezeRecordQuery } from '@eastcoal/api/trade/interface'
import { queryMemberFreezeRecordApi } from '@eastcoal/api/trade/unfreezeApplyOperation/queryMemberFreezeRecord'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { RemoteTableProps } from '@eastcoal/common/components/RemoteTable/interface'

import { BizTypeSelect } from '../BizTypeSelect'

import {
  CheckFreezeAmountListButtonProps,
  FreezeAmountDetail
} from './interface'

const freezeColumns: RemoteTableProps<
  FreezeAmountDetail,
  FreezeRecordQuery
>['columns'] = [
  {
    dataIndex: 'sort',
    title: '序号',
    width: 60,
    align: 'center'
  },
  {
    dataIndex: 'title',
    title: '资金冻结项',
    width: 240
  },
  {
    dataIndex: 'type',
    title: '资金类型',
    width: 80
  },
  {
    dataIndex: 'deliveryPlaceName',
    title: '存放地'
  },
  {
    dataIndex: 'amount',
    title: '冻结金额',
    valueType: 'digit',
    align: 'right'
  },
  {
    dataIndex: 'applyTime',
    title: '冻结时间'
  }
]

export const CheckFreezeAmountListButton = ({
  memberId
}: CheckFreezeAmountListButtonProps) => {
  const [visible, visibleAction] = useBoolean(false)

  const { blue, paddingXXS } = useTheme()
  return (
    <>
      <Modal
        cancelButtonProps={{ hidden: true }}
        closable={false}
        open={visible}
        title='冻结金额详情'
        width={800}
        onOk={visibleAction.setFalse}
      >
        <RemoteTable
          columns={freezeColumns}
          pagination={false}
          refreshDeps={[memberId]}
          rowKey='sort'
          scroll={{ y: 488 }}
          api={(params?: FreezeRecordQuery) => {
            return queryMemberFreezeRecordApi({
              bizType: params?.['bizType'],
              memberId
            }).then(detail =>
              detail.map((item, index) => ({ ...item, sort: `${index + 1}` }))
            )
          }}
          toolbar={{
            actions: ['refresh'],
            extraActions: {
              left: [<BizTypeSelect key='bizTypeSelect' />]
            }
          }}
        />
      </Modal>
      <Tooltip title='点击查看冻结金额详情'>
        <Button
          icon={<ContainerOutlined style={{ color: blue }} />}
          style={{ paddingInline: paddingXXS }}
          type='text'
          onClick={visibleAction.setTrue}
        />
      </Tooltip>
    </>
  )
}
